// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey_featuredItem__X5\\+L9 {
  flex: 1 1;
  margin: 0px 20px;
  padding: 30px;
  border-radius: 10px;
  cursor:default;
  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.survey_container_survey__N7-Tm{
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;
}

.survey_container_datacapture__UvMA3{
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  
  justify-content: space-around;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;
}

.survey_container_dataupdate__Fx-AJ{
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  
  justify-content: space-around;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;
}
.survey_container_row__KoSSf{
  display: flex;
  flex: 1 1; 

  flex-direction: column;
  align-content: center;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
}

.survey_printviewDialog__u-U5d {
  min-width: 90vw !important;
  max-width: 90vw !important;
}

.survey_survey_form__JRqbS{
  display: flex;
  flex: 1 1; 
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  width: 75%;
}

.survey_container_surveys_finished__VibRW {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  width: 100%;
  border-left: none;
}

.survey_tableScroll__jPh\\+Z {
  overflow:auto;
  width:1000px;
  display: block;
}

.survey_percentage__P-P8y{
	display:inline-block;
	position: relative;
	}
.survey_percentage__P-P8y input{
	padding-right:15px;
	}
.survey_percentage__P-P8y:before {
	position: absolute;
    content:"%";
    right:5px;
 	}

.survey_cellHint__P43F- {
  font-family: var(--bookFontFamily);
  margin-left: 0px;
  white-space: pre-wrap ; 
}

.survey_cellHint__P43F- .survey_tooltiptext__tNTdP {
  font-size: 12px;
  visibility: hidden;
  width: 20%;
  background-color: var(--hsrcLightRed);
  color: var(--hsrcMainRed);
  text-align:left;
  margin-left: 20px;
  padding: 10px;
  border: 1px solid var(--hsrcMainRed);
  box-sizing: border-box;
  border-radius: 5px;
  
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1; 
}

.survey_cellHint__P43F-:hover .survey_tooltiptext__tNTdP {
  visibility: visible;
}

.survey_cellHint__P43F- .survey_normalText__g301Y {
  border-radius: '0px'
}

.survey_cellHint__P43F- .survey_redText__-yytV {
  border-radius: '0px';
  color: var(--hsrcMainRed);
}

.survey_confirmDialogOverlay__au0gW {
  z-index: 10000; 
  pointer-events: none;
}


.survey_confirmDownloadButton__5INWw {
  background-color: var(--hsrcYellow);
   /* Green */
   border: none;
   color: black;
   font-size: 24px;
   padding: 20px;
   width: 300px;
   text-align: center;
   text-decoration: none;
   display: inline-block;
   margin: 15px 20px;
   cursor: pointer;
   border-radius: 8px;
   filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25)); 
}


.survey_breadcrumbs__ZklSX{
  width: 100%;
  display: flex;
  flex: 1 1; 
  flex-direction: row;
  align-content: center;
  justify-content: flex-start;
  background-color: var(--hsrcBackgroundLight);
  padding-bottom: 2.5rem;
}











.survey_title__sVhzG {
  margin: 20;
  font-size: 25;    
  text-align: 'center';    
  background-color: '#e4e4e4';    
  text-transform: 'uppercase';    
  font-family: var(--bookFontFamily);
}

.survey_body__NfNMK {
  flex-grow: 1;    
}

.survey_row__eOoTr {
  flex-grow: 1 ;    
  flex-direction: 'row';    
}

.survey_block__D4lsN {
  flex-grow: 1;    
}

.survey_text__MuWKI {
  width: '60%';    
  margin: 10;    
  font-family: var(--bookFontFamily);
  text-align: 'justify';    
}

.survey_fill1__Y6Jk6 {
  width: '40%';    
  background-color: '#e14427';    
}

.survey_fill2__8WdKP {
  flex-grow: 2;    
  background-color: '#e6672d';    
}

.survey_fill3__2q5ON {
  flex-grow: 2;    
  background-color: '#e78632';    
}

.survey_fill4__TJWnd {
  flex-grow: 2;    
  background-color: '#e29e37';    
}

.survey_page__oumQm {
  flex-direction: row;
  background-color: '#E4E4E4';
}

.survey_section__GGlls {
  margin: 10;
  padding: 10;
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/pages/RespondentDashboard/pages/Survey/survey.module.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EAEd,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;;EAEzB,6BAA6B;EAC7B,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;;EAEzB,6BAA6B;EAC7B,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAO;;EAEP,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB;AACD;CACC,kBAAkB;CAClB;AACD;CACC,kBAAkB;IACf,WAAW;IACX,SAAS;EACX;;AAEF;EACE,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;;EAElB,oDAAoD;EACpD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;;AAGA;EACE,mCAAmC;GAClC,UAAU;GACV,YAAY;GACZ,YAAY;GACZ,eAAe;GACf,aAAa;GACb,YAAY;GACZ,kBAAkB;GAClB,qBAAqB;GACrB,qBAAqB;GACrB,iBAAiB;GACjB,eAAe;GACf,kBAAkB;GAClB,oDAAoD;AACvD;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;EAC5C,sBAAsB;AACxB;;;;;;;;;;;;AAYA;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd","sourcesContent":[".featuredItem {\r\n  flex: 1;\r\n  margin: 0px 20px;\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n  cursor:default;\r\n  -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.container_survey{\r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: center;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n}\r\n\r\n.container_datacapture{\r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: flex-start;\r\n  \r\n  justify-content: space-around;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n}\r\n\r\n.container_dataupdate{\r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: flex-start;\r\n  \r\n  justify-content: space-around;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n}\r\n.container_row{\r\n  display: flex;\r\n  flex: 1; \r\n\r\n  flex-direction: column;\r\n  align-content: center;\r\n  align-items: flex-start;\r\n  align-content: center;\r\n  justify-content: center;\r\n}\r\n\r\n.printviewDialog {\r\n  min-width: 90vw !important;\r\n  max-width: 90vw !important;\r\n}\r\n\r\n.survey_form{\r\n  display: flex;\r\n  flex: 1; \r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: flex-start;\r\n  justify-content: flex-start;\r\n  width: 75%;\r\n}\r\n\r\n.container_surveys_finished {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  align-items: flex-start;\r\n  align-content: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  border-left: none;\r\n}\r\n\r\n.tableScroll {\r\n  overflow:auto;\r\n  width:1000px;\r\n  display: block;\r\n}\r\n\r\n.percentage{\r\n\tdisplay:inline-block;\r\n\tposition: relative;\r\n\t}\r\n.percentage input{\r\n\tpadding-right:15px;\r\n\t}\r\n.percentage:before {\r\n\tposition: absolute;\r\n    content:\"%\";\r\n    right:5px;\r\n \t}\r\n\r\n.cellHint {\r\n  font-family: var(--bookFontFamily);\r\n  margin-left: 0px;\r\n  white-space: pre-wrap ; \r\n}\r\n\r\n.cellHint .tooltiptext {\r\n  font-size: 12px;\r\n  visibility: hidden;\r\n  width: 20%;\r\n  background-color: var(--hsrcLightRed);\r\n  color: var(--hsrcMainRed);\r\n  text-align:left;\r\n  margin-left: 20px;\r\n  padding: 10px;\r\n  border: 1px solid var(--hsrcMainRed);\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n  \r\n  /* Position the tooltip text - see examples below! */\r\n  position: absolute;\r\n  z-index: 1; \r\n}\r\n\r\n.cellHint:hover .tooltiptext {\r\n  visibility: visible;\r\n}\r\n\r\n.cellHint .normalText {\r\n  border-radius: '0px'\r\n}\r\n\r\n.cellHint .redText {\r\n  border-radius: '0px';\r\n  color: var(--hsrcMainRed);\r\n}\r\n\r\n.confirmDialogOverlay {\r\n  z-index: 10000; \r\n  pointer-events: none;\r\n}\r\n\r\n\r\n.confirmDownloadButton {\r\n  background-color: var(--hsrcYellow);\r\n   /* Green */\r\n   border: none;\r\n   color: black;\r\n   font-size: 24px;\r\n   padding: 20px;\r\n   width: 300px;\r\n   text-align: center;\r\n   text-decoration: none;\r\n   display: inline-block;\r\n   margin: 15px 20px;\r\n   cursor: pointer;\r\n   border-radius: 8px;\r\n   filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25)); \r\n}\r\n\r\n\r\n.breadcrumbs{\r\n  width: 100%;\r\n  display: flex;\r\n  flex: 1; \r\n  flex-direction: row;\r\n  align-content: center;\r\n  justify-content: flex-start;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  padding-bottom: 2.5rem;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.title {\r\n  margin: 20;\r\n  font-size: 25;    \r\n  text-align: 'center';    \r\n  background-color: '#e4e4e4';    \r\n  text-transform: 'uppercase';    \r\n  font-family: var(--bookFontFamily);\r\n}\r\n\r\n.body {\r\n  flex-grow: 1;    \r\n}\r\n\r\n.row {\r\n  flex-grow: 1 ;    \r\n  flex-direction: 'row';    \r\n}\r\n\r\n.block {\r\n  flex-grow: 1;    \r\n}\r\n\r\n.text {\r\n  width: '60%';    \r\n  margin: 10;    \r\n  font-family: var(--bookFontFamily);\r\n  text-align: 'justify';    \r\n}\r\n\r\n.fill1 {\r\n  width: '40%';    \r\n  background-color: '#e14427';    \r\n}\r\n\r\n.fill2 {\r\n  flex-grow: 2;    \r\n  background-color: '#e6672d';    \r\n}\r\n\r\n.fill3 {\r\n  flex-grow: 2;    \r\n  background-color: '#e78632';    \r\n}\r\n\r\n.fill4 {\r\n  flex-grow: 2;    \r\n  background-color: '#e29e37';    \r\n}\r\n\r\n.page {\r\n  flex-direction: row;\r\n  background-color: '#E4E4E4';\r\n}\r\n\r\n.section {\r\n  margin: 10;\r\n  padding: 10;\r\n  flex-grow: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredItem": `survey_featuredItem__X5+L9`,
	"container_survey": `survey_container_survey__N7-Tm`,
	"container_datacapture": `survey_container_datacapture__UvMA3`,
	"container_dataupdate": `survey_container_dataupdate__Fx-AJ`,
	"container_row": `survey_container_row__KoSSf`,
	"printviewDialog": `survey_printviewDialog__u-U5d`,
	"survey_form": `survey_survey_form__JRqbS`,
	"container_surveys_finished": `survey_container_surveys_finished__VibRW`,
	"tableScroll": `survey_tableScroll__jPh+Z`,
	"percentage": `survey_percentage__P-P8y`,
	"cellHint": `survey_cellHint__P43F-`,
	"tooltiptext": `survey_tooltiptext__tNTdP`,
	"normalText": `survey_normalText__g301Y`,
	"redText": `survey_redText__-yytV`,
	"confirmDialogOverlay": `survey_confirmDialogOverlay__au0gW`,
	"confirmDownloadButton": `survey_confirmDownloadButton__5INWw`,
	"breadcrumbs": `survey_breadcrumbs__ZklSX`,
	"title": `survey_title__sVhzG`,
	"body": `survey_body__NfNMK`,
	"row": `survey_row__eOoTr`,
	"block": `survey_block__D4lsN`,
	"text": `survey_text__MuWKI`,
	"fill1": `survey_fill1__Y6Jk6`,
	"fill2": `survey_fill2__8WdKP`,
	"fill3": `survey_fill3__2q5ON`,
	"fill4": `survey_fill4__TJWnd`,
	"page": `survey_page__oumQm`,
	"section": `survey_section__GGlls`
};
export default ___CSS_LOADER_EXPORT___;
